import { withNestedView, loadView } from '@/router/routerHelpers';

const loadReportView = withNestedView('reports');

export default [
  {
    path: '/reports/shared',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: ':pid/:id?',
        name: 'reportShared',
        props: true,
        component: loadReportView('ReportShared'),
      },
    ],
  },
  {
    path: '/exports/shared/:pid',
    name: 'exportShared',
    props: true,
    component: loadView('exports/ExportShared'),
  },
];
